export const MENU_MAX_WIDTH = 340;
